import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d451a1ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-page fullscreen bg-blue text-white text-center q-pa-md flex flex-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "error-message text-h2",
  style: {"opacity":"0.4"}
}, " Oops! Parece que esta página não existe... ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_q_avatar, { class: "error-image" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "sentiment_dissatisfied",
            size: "250px"
          })
        ]),
        _: 1
      }),
      _hoisted_2,
      _createVNode(_component_q_btn, {
        class: "error-button q-mt-xl",
        color: "white",
        "text-color": "blue",
        unelevated: "",
        onClick: _ctx.goToHome,
        label: "Voltar para o Início",
        "no-caps": ""
      }, null, 8, ["onClick"])
    ])
  ]))
}